<template>
  <module-template
    id="scrolltainer"
    :title="$t('global.retention-policy.policies')"
    :canCreate="$store.state.retentionPolicyPermission"
    :createToolTip="
      $t('global.header.newVowel', [
        $t('global.retention-policy.label').toLowerCase(),
      ])
    "
    @newItem="create"
  >
    <ooliba-basic-table
      :headers="headers"
      :items="items"
      :loading="busy"
      sort-by="name"
      no-pagination
      :height="tableHeight(85, items?.length)"
      @row-clicked="onRowClick"
    >
      <template v-slot:[`item.standaloneRuns`]="{ item }">
        {{ formatCategory(item.standaloneRuns) }}
      </template>
      <template v-slot:[`item.bpInstanceRuns`]="{ item }">
        {{ formatCategory(item.bpInstanceRuns) }}
      </template>
      <template v-slot:[`item.bpInstances`]="{ item }">
        {{ formatCategory(item.bpInstances) }}
      </template>
      <template v-slot:[`item.unusedFiles`]="{ item }">
        {{ formatCategory(item.unusedFiles) }}
      </template>
    </ooliba-basic-table>
  </module-template>
</template>

<script>
import { get } from "@/model/api";
import ModuleTemplate from "@/components/layout/ModuleTemplate";
import OolibaBasicTable from "@/components/OolibaBasicTable";
import { tableHeight } from "@/model/util";

export default {
  name: "RetentionPolicyList",
  components: {
    OolibaBasicTable,
    ModuleTemplate,
  },
  data() {
    return {
      headers: [
        { text: this.$t("global.concepts.name"), value: "name" },
        {
          text: this.$t("global.retention-policy.standalone-runs"),
          value: "standaloneRuns",
        },
        {
          text: this.$t("global.retention-policy.bp-instance-runs"),
          value: "bpInstanceRuns",
        },
        {
          text: this.$t("global.retention-policy.bp-instances"),
          value: "bpInstances",
        },
        {
          text: this.$t("global.retention-policy.unused-files"),
          value: "unusedFiles",
        },
        {
          text: this.$t("global.retention-policy.file-envs-using"),
          value: "fileEnvCount",
        },
      ],
      items: [],
      busy: true,
    };
  },

  methods: {
    tableHeight,

    create() {
      this.$router.push({ name: "Create retention policy" });
    },

    async getPolicies() {
      return await get("/retention-policy").catch((error) => {
        this.$store.commit("showError", error);
      });
    },

    onRowClick(record) {
      const policyId = record.id;
      this.$router.push({
        name: "Retention policy",
        params: { policyId: policyId },
      });
    },

    formatCategory(category) {
      if (!category) return "-";
      if (category.noDeletion) {
        return this.$t("global.retention-policy.no-deletion");
      }
      if (category.value && category.unit) {
        const unitText = this.$t(
          "global.retention-policy.unit." + category.unit.toLowerCase()
        );
        return `${category.value} ${unitText}`;
      }
      return "-";
    },
  },

  async created() {
    const policies = await this.getPolicies();
    if (policies) {
      policies.forEach((policy) => {
        this.items.push({
          id: policy.id,
          name: policy.name,
          standaloneRuns: policy.standaloneRuns,
          bpInstanceRuns: policy.bpInstanceRuns,
          bpInstances: policy.bpInstances,
          unusedFiles: policy.unusedFiles,
          fileEnvCount: policy.fileEnvCount,
        });
      });
    }
    this.busy = false;
  },
};
</script>
